import React, { ReactElement, useState } from 'react';
import { stroot } from '@birdi/js-sdk';
import { css } from '@emotion/react';
import { inspection as inspectionAPI } from '@birdi/js-sdk';
import { blocks } from '@birdi/theme';

export const GenerateReportBtn = ({ inspectionId }): ReactElement => {
  const [generating, setGenerating] = useState<boolean>(false);
  const generateReport = () => {
    setGenerating(true);
    inspectionAPI.generateReport(stroot('yus9co'), inspectionId).then(() => {
      setGenerating(false);
    });
  };
  return (
    <button
      type="button"
      css={(theme) => css`
        ${blocks.button(theme)}
        margin-left: 8px;
      `}
      onClick={generateReport}
      disabled={generating}
    >
      Generate reports
    </button>
  );
};
